<div class="row">
    <div class="col-8">
        <app-pagetitle title="Notification Template Manager"></app-pagetitle>

    </div>
    <div class="col-4 text-end" *ngIf="activeTab === 'manage'">
        @if(!showTemplateForm){
        <button class="btn btn-primary" (click)="toggleTemplateForm()" [disabled]="isLoading">
            + New Template
        </button>
        }

    </div>
</div>
<div class="page-content-wrapper">

    <app-loader [loading]="isLoading"></app-loader>

    <div [class.loading-content]="isLoading">


        <div class="container">

            <ul class="nav nav-tabs analytics-tabs mb-4">

                <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'manage'" (click)="activeTab = 'manage'">
                        Manage Templates
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'send'" (click)="activeTab = 'send'">
                        Send Notification
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'logs'" (click)="activeTab = 'logs'">
                        View Logs
                    </a>
                </li>

            </ul>
            <!-- TAB 1: MANAGE TEMPLATES -->
            <div class="tab-content" *ngIf="activeTab === 'manage'">

                <!-- Template Form -->
                @if(isLoading){
                <div class="text-center fw-bold">Loading Templates...</div>
                }
                @if(showTemplateForm){
                <div class="form-card">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleTemplateForm()">
                            ←
                        </button>
                        <h4 class="card-title mb-0 fw-semibold">{{ selectedTemplate ? 'Edit Template' : 'Create New
                            Template' }}
                        </h4>
                    </div>

                    <div class="form-group">
                        <label for="template-code">Template Code <span class="required">*</span></label>
                        <input type="text" id="template-code" class="form-control" [(ngModel)]="templateCode"
                            [disabled]="selectedTemplate || isLoading"
                            placeholder="e.g., DOCUMENT_CREATED, SIGNING_REMINDER" />
                        <small class="help-text">Unique identifier for this template (e.g., DOCUMENT_CREATED)</small>
                    </div>

                    <div class="form-group">
                        <label for="template-name">Template Name <span class="required">*</span></label>
                        <input type="text" id="template-name" class="form-control" [(ngModel)]="templateName"
                            [disabled]="isLoading" placeholder="e.g., Document Created Notification" />
                    </div>

                    <div class="form-group">
                        <label for="template-desc">Description</label>
                        <textarea id="template-desc" class="form-control" [(ngModel)]="templateDescription"
                            [disabled]="isLoading" placeholder="Describe when this template is used" rows="2"
                            maxlength="500"></textarea>
                        <small class="text-muted">
                            {{ templateDescription?.length || 0 }}/500 characters
                        </small>
                    </div>

                    <div class="form-group">
                        <label for="email-subject">Email Subject <span class="required">*</span></label>
                        <input type="text" id="email-subject" class="form-control" [(ngModel)]="emailSubject"
                            [disabled]="isLoading" placeholder="e.g., Please sign docs" />
                        <small class="help-text">Use variable for dynamic content</small>
                    </div>

                    <div class="form-section">
                        <h5>Email Body</h5>
                        <div class="editor-container">
                            <ckeditor [editor]="Editor" [config]="editorConfig" [(ngModel)]="emailBody"
                                (change)="onEditorChange($event)"></ckeditor>

                        </div>
                        <div class="row mt-0">
                            <small class="text-muted">
                                {{ getPlainTextLength(emailBody) }}/2000 characters
                            </small>
                        </div>

                        <small class="help-text">Note: Use variable syntax for dynamic content. Example: signerName,
                            documentName</small>
                    </div>

                    <div class="form-section mb-4">
                        <h5>SMS Body</h5>

                        <textarea class="form-control" rows="4" [(ngModel)]="smsBody" maxlength="500"
                            placeholder="Enter SMS message here..."></textarea>
                        <small class="text-muted">
                            {{ smsBody?.length || 0 }}/500 characters
                        </small>
                    </div>

                    <div class="form-section mb-4">
                        <h5>WhatsApp Body</h5>
                        <textarea class="form-control" rows="4" [(ngModel)]="whatsappBody" maxlength="500"
                            placeholder="Enter WhatsApp message here...">
                </textarea>

                        <small class="text-muted">
                            {{ whatsappBody?.length || 0 }}/500 characters
                        </small>
                    </div>


                    <button class="btn btn-secondary me-3" (click)="toggleTemplateForm()" [disabled]="isLoading">
                        Cancel
                    </button>
                    <button class="btn btn-primary" (click)="saveTemplate()"
                        [disabled]="isLoading || !templateCode || !templateName || !emailSubject || !emailBody">
                        Save Template
                    </button>
                </div>
                }
            </div>

            <!-- Templates List -->
            @if(!showTemplateForm && activeTab !== 'logs' && activeTab !== 'send'){
            <div class="templates-grid">
                <div class="template-card" *ngFor="let template of templates">
                    <div class="template-header">
                        <h5>{{ template.name }}</h5>
                        <span class="template-code">{{ template.code }}</span>
                    </div>
                    <p class="template-description">{{ template.description }}</p>
                    <div class="template-channels">
                        <span *ngIf="template.email" class="badge badge-email">📧 Email</span>
                        <span *ngIf="template.sms" class="badge badge-sms">💬 SMS</span>
                        <span *ngIf="template.whatsapp" class="badge badge-whatsapp">📱 WhatsApp</span>
                    </div>
                    <div class="template-actions">
                        <button class="btn btn-sm btn-secondary" (click)="editTemplate(template)"
                            [disabled]="isLoading">
                            ✏️ Edit
                        </button>
                        <!-- <button class="btn btn-sm btn-danger" (click)="deleteTemplate(template.code)" [disabled]="isLoading">
                    🗑️ Delete
                </button> -->
                    </div>
                </div>

                <div class="empty-state" *ngIf="templates.length === 0 && !isLoading">
                    <p>No templates yet. Click "New Template" to create one.</p>
                </div>
            </div>
            }
        </div>

        <!-- TAB 2: SEND NOTIFICATION -->
        <div class="tab-content" *ngIf="activeTab === 'send'">

            <div class="form-card">
                <div class="row">
                    <div class="col-6">
                        <label class="filter-label">Template<span class="required text-danger"> * </span></label>
                        <select class="form-select" [(ngModel)]="selectedTemplate"
                            (change)="toggleSendForm(selectedTemplate)">

                            <option *ngFor="let template of templates" [ngValue]="template">
                                {{ template.code }}
                            </option>

                        </select>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="recipient">Recipient <span class="required">*</span></label>
                            <input type="text" id="recipient" class="form-control" [(ngModel)]="recipient"
                                [disabled]="isLoading" placeholder="Enter email address or phone number" />
                        </div>
                    </div>
                </div>

                <!-- Channels Selection -->
                <div class="form-group">
                    <label>Channels <span class="required">*</span></label>
                    <div class="channels-selector">
                        <label *ngFor="let channel of channels" class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="channel" [value]="channel"
                                [(ngModel)]="selectedChannel" [disabled]="isLoading" />

                            <span class="form-check-label">
                                {{ channel | titlecase }}
                            </span>
                        </label>

                    </div>

                </div>

                <!-- Variables Input -->
                <div class="form-group" *ngIf="requiredVariables.length > 0">
                    <label>Template Variables <span class="required">*</span></label>
                    <div class="variables-section">
                        <div class="variable-input" *ngFor="let variable of requiredVariables">
                            <label [for]="'var-' + variable">variable</label>
                            <input [id]="'var-' + variable" type="text" class="form-control"
                                [(ngModel)]="variables[variable]" [disabled]="isLoading"
                                [placeholder]="'Enter value for {{' + variable + '}}'" />
                        </div>
                    </div>
                </div>

                <div class="form-actions">
                    <button class="btn btn-primary" (click)="sendNotification()"
                        [disabled]="isLoading || !recipient || selectedChannel === ''">
                        <span *ngIf="!isLoading">✉️ Send Notification</span>
                        <span *ngIf="isLoading">Sending...</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- TAB 3: NOTIFICATION LOGS -->
        <div class="tab-content" *ngIf="activeTab === 'logs'">
            <div class="card">
                <div class="card-body">
                    <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                        [templateCodeOptions]="templateCodeOptions" [channelOptions]="channelOptions"
                        searchBY="Recipient & Template code"></app-filter>

                    <p-table #dt [value]="notificationLogs" [lazy]="true" (onLazyLoad)="loadNotificationLogs($event)"
                        [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="isLoading"
                        [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll" styleClass="p-datatable-sm fs-6"
                        [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Template Code</th>
                                <th>Channel</th>
                                <th>Recipient</th>
                                <th>Status</th>
                                <th>Sent At</th>
                                <th>Error</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-log>
                            <tr>
                                <td><strong>{{ log.templateCode }}</strong></td>
                                <td>{{ log.channel }}</td>
                                <td>{{ log.recipient }}</td>
                                <td>
                                    <div class="badge font-size-12" [ngClass]="{
                                            'bg-success-subtle text-success': log.status === 'sent',
                                            'bg-warning-subtle text-warning': log.status === 'pending',
                                            'bg-danger-subtle text-danger': log.status === 'failed'
                                        }">{{ log.status }}</div>
                                </td>
                                <td>{{ (log.sentAt | date:'short') || '-' }}</td>
                                <td class="text-danger">{{ log.error || '-' }}</td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="9" class="text-center py-4 text-muted">
                                    <i class="mdi mdi-database-off-outline me-2"></i>
                                    No log found
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>